import { amplitudeProductTypeByPaymentTypeAndChannel } from 'Utils/mappers/amplitude';
import getStoredApplication from 'Redesign_Funnel/utils/getStoredApplication';

export const getApplicationInformation = () => {
  const application = getStoredApplication();
  const {
    applicationProcessId,
    customerId,
    productType,
    channel,
  } = application;
  return {
    applicationProcessId,
    customerId,
    productType: amplitudeProductTypeByPaymentTypeAndChannel(productType, channel, true),
  };
};
